import { io } from 'socket.io-client';

export * from 'socket.io-client';

window.io = io;
